import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from '../base/button';

const ExternalButton = ({ slice }) => {
    return (
        <SButton>
            <Button to={slice.button_url.url} external={true}>
                {slice.button_label}
            </Button>
        </SButton>
    );
};

const SButton = styled.div`
    * + &,
    & + * {
        margin-top: 20px;
    }
`;

export default ExternalButton;

ExternalButton.propTypes = {
    slice: PropTypes.object.isRequired
};
